import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';

export const layoutRouting: Routes = [
  {
    path: '',
    component: LayoutComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(layoutRouting)],
  exports: [RouterModule],
})
export class LayoutRoutingModule { }
